class GiftCardBalanceCheck extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.form = this.els.form.element
    this.getGiftCardBalance = this.getGiftCardBalance.bind(this)
    this.populateResults = this.populateResults.bind(this)
  }

  setupListeners () {
    super.setupListeners()

    this.els.submit.element.addEventListener('click', e => {
      e.preventDefault()

      if (this.els.submit.element.ariaDisabled === 'true') return

      if (this.form.checkValidity()) {
        const formData = Object.fromEntries(new FormData(this.form))
        this.getGiftCardBalance(
          formData.gift_card_email,
          formData.gift_card_number,
        )
      } else {
        this.form.reportValidity()
      }
    })
  }

  async getGiftCardBalance (email, code) {
    const appUrl = this.dataset.appUrl

    const headers = new Headers()
    const formData = new FormData()

    formData.append('code', code)
    formData.append('email', email)

    headers.append('X-Shop-Domain', window.Shopify.shop)

    const response = await fetch(appUrl, {
      method: 'POST',
      body: formData,
      headers,
    })

    if (response.ok) {
      const data = await response.json()
      this.populateResults(data)
    } else {
      this.els.error.element.classList.remove(
        'gc-GiftCardBalance_InputError-hidden',
      )
    }
  }

  populateResults (response) {
    this.els.error.element.classList.add('gc-GiftCardBalance_InputError-hidden')

    // Update Balance
    let remainingBalance = response.data.giftCard.balance.amount

    if (remainingBalance % 1 === 0) {
      remainingBalance = remainingBalance.split('.')[0]
    } else {
      remainingBalance = remainingBalance.toFixed(2)
    }

    const currencySymbol = this.getCurrencySymbol(
      response.data.giftCard.balance.currencyCode,
    )

    remainingBalance = `${currencySymbol}${remainingBalance}`

    this.els.value.element.textContent = remainingBalance

    // Update Masked Gift Card Code
    const splitCode = response.data.giftCard.maskedCode.split(' ')
    this.els.code.element.textContent = splitCode[splitCode.length - 1]

    // Update Expiry Date
    const date = response.data.giftCard.expiresOn
    if (!date) {
      this.els.expiryElement.element.style.display = 'none'
    } else {
      const formattedDate = new Date(date)
      const day = String(formattedDate.getDate()).padStart(2, '0')
      const month = String(formattedDate.getMonth() + 1).padStart(2, '0')
      const year = String(formattedDate.getFullYear()).slice(-2)
      const formattedExpiry = `${day}/${month}/${year}`

      this.els.expiry.element.textContent = formattedExpiry
    }

    // Show Response
    this.els.defaultForm.element.setAttribute('aria-hidden', 'true')
    this.els.responseForm.element.setAttribute('aria-hidden', 'false')
  }

  getCurrencySymbol (currency) {
    switch (currency) {
      case 'USD':
        return '$'
      case 'EUR':
        return '€'
      case 'GBP':
        return '£'
      default:
        return currency
    }
  }
}

if (!customElements.get('gift-card-balance-check')) {
  customElements.define('gift-card-balance-check', GiftCardBalanceCheck)
}
